import { Box, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { useStyles } from "./style";
import { useFormik } from "formik";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import CommonButton from "src/components/CommonButton/CommonButton";
import { object, string } from "yup";
import {
  selectAllYardsListing,
  selectedYardId,
  selectedYardRowId,
  selectedYardRowSlotId,
  selectAllYardRowsListing,
  addYardId,
  selectOnlyAvailableAllSlotsByRowId,
  selectComponentYardId,
  selectedVehicleId,
  addSlotId,
  drawerOpenedFor,
  resetForm,
} from "src/app-redux/yard/yardSlice";

import {
  getAllRowsByYardIdAction,
  getAllAvailableSlotsByRowIdAction,
  updateYardSlotAction,
  getYardRowsSlotsAction,
  getYardTrail,
  removeVehicleFromYard,
} from "src/app-redux/yard/actions/yardActions";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { currentSelectedVehicleId, selectVehicleDetails } from "src/app-redux/vehicle/vehicleSlice";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";

export interface IDrawerSlotChangeProps {}

export default function DrawerSlotChange(props: IDrawerSlotChangeProps) {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  //Redux
  const componentYardId = useAppSelector(selectComponentYardId);
  const currVehicleId = useAppSelector(selectedVehicleId);
  const currGatePassId = useAppSelector(currentSelectedVehicleId);
  const selectedYard = useAppSelector(selectedYardId);
  const selectedYardRow = useAppSelector(selectedYardRowId);
  const selectedYardRowSlot = useAppSelector(selectedYardRowSlotId);
  const [currYardId, setCurrYardId] = React.useState<any>(null);
  const [currRowId, setCurrRowId] = React.useState<any>(null);
  const [currRowSlotId, setCurrRowSlotId] = React.useState<any>(null);

  const allYards: any = useAppSelector(selectAllYardsListing);
  const allRows: any = useAppSelector(selectAllYardRowsListing);
  const allSlots: any = useAppSelector(selectOnlyAvailableAllSlotsByRowId);
  const redirectedFrom = useAppSelector(drawerOpenedFor);
  const vehicleDetailsResponse: any = useAppSelector(selectVehicleDetails);
  const [removedFromYard, setremoved] = React.useState(false);

  useEffect(() => {
    if (
      redirectedFrom.payload.yard.drawerOpenedFor === "vehicleNumber" &&
      vehicleDetailsResponse.allotedYardDetails
    ) {
      setCurrYardId(vehicleDetailsResponse.allotedYardDetails.yardId);
      setCurrRowId(vehicleDetailsResponse.allotedYardDetails.rowId);
      setCurrRowSlotId(vehicleDetailsResponse.allotedYardDetails.slotId);
      formik.setFieldValue("yardId", vehicleDetailsResponse.allotedYardDetails.yardId);
      formik.setFieldValue("rowId", vehicleDetailsResponse.allotedYardDetails.rowId);
      formik.setFieldValue("slotId", vehicleDetailsResponse.allotedYardDetails.slotId);
    } else {
      setCurrYardId(selectedYard);
      setCurrRowId(selectedYardRow);
      setCurrRowSlotId(selectedYardRowSlot);
    }
  }, []);
  useEffect(() => {
    currYardId ? getYardRows() : "";
  }, [currYardId]);
  const getYardRows = async () => {
    await dispatch(getAllRowsByYardIdAction(currYardId)); // get all Rows by Yard Id
  };
  useEffect(() => {
    currRowId ? getAvailableSlots() : "";
  }, [currRowId]);
  const getAvailableSlots = async () => {
    await dispatch(getAllAvailableSlotsByRowIdAction(currRowId)); // get all Slots by Row Id
  };

  const validationSchema = object({
    yardId: string().required("This field is required"),
    rowId: string().required("This field is required"),
    slotId: string().required("This field is required."),
  });
  const formik = useFormik<any>({
    enableReinitialize: true,
    initialValues: {
      gatePassId: currGatePassId || "",
      yardId: currYardId || "",
      rowId: currRowId || "",
      slotId: currRowSlotId || "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      const res: any = await dispatch(updateYardSlotAction(values));
      if (res.payload) {
        setCurrRowSlotId(res.meta.arg.slotId);
        actions.setSubmitting(false);
        dispatch(addSlotId(values.slotId));
        dispatch(getYardTrail(currVehicleId));
        dispatch(getYardRowsSlotsAction(componentYardId));
        dispatch(drawerOpenedFor("image"));
        dispatch(getAllAvailableSlotsByRowIdAction(currRowId));
        await dispatch(getVehicleDetailsByIdAction(currGatePassId));
        return;
      }
    },
  });

  const [isOpenDeleteDailog, setIsOpenDeleteDailog] = useState<boolean>(false);

  const handleCloseDeleteDialog = () => {
    setIsOpenDeleteDailog(false);
  };

  const handleDeleteDialog = async () => {
    setIsOpenDeleteDailog(false);
    const data = { slotId: currRowSlotId, gatePassId: currGatePassId };
    const res = await dispatch(removeVehicleFromYard(data));
    if (res.payload) {
      dispatch(getYardTrail(currVehicleId));
      dispatch(getYardRowsSlotsAction(componentYardId));
      setremoved(true);
      return;
    }
  };

  const removeFromYard = async () => {
    setIsOpenDeleteDailog(true);
  };

  const resetSlotForm = () => {
    dispatch(resetForm());
    formik.setFieldValue("yardId", "");
    formik.setFieldValue("rowId", "");
    formik.setFieldValue("slotId", "");
    setCurrYardId(null);
    setCurrRowId(null);
    setCurrRowSlotId(null);
  };
  return (
    <div className={classes.drawerDetails}>
      {/* Drawer Status Item  */}
      <Grid container spacing={2} className="topContainer" style={{ marginTop: "5px" }}>
        <Grid container direction="row" className="itemRow" spacing={2}>
          <Grid item xs={12} md={12}>
            <Box>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                label="Yard"
                placeholder="Yard"
                name="statusId"
                disableClearable={true}
                optionsType={allYards}
                required
                getOptionLabel={(option: any) => option.name || ""}
                value={allYards.find((st: any) => st.id === formik.values.yardId) || null}
                onChange={(option: any) => {
                  if (option && option.id !== 0) {
                    dispatch(addYardId(option.id));
                    setCurrYardId(option.id);
                    formik.setFieldValue("yardId", option.id);
                    formik.setFieldValue("rowId", "");
                    formik.setFieldValue("slotId", "");
                  }
                }}
                error={formik.touched.yardId && Boolean(formik.errors.yardId)}
                helperText={formik.touched.yardId && formik.errors.yardId}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                error={formik.touched.rowId && Boolean(formik.errors.rowId)}
                helperText={formik.touched.rowId && formik.errors.rowId}
                label="Row"
                placeholder="Select Row"
                name="rowId"
                disableClearable={true}
                optionsType={allRows}
                required
                getOptionLabel={(option: any) => option.rowName || ""}
                value={allRows.find((st: any) => st.yardRowId === formik.values.rowId) || null}
                onChange={(option: any) => {
                  if (option && option.id !== 0) {
                    dispatch(getAllAvailableSlotsByRowIdAction(option.yardRowId));
                    setCurrRowId(option.yardRowId);
                    formik.setFieldValue("rowId", option.yardRowId);
                    formik.setFieldValue("slotId", "");
                  }
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                error={formik.touched.slotId && Boolean(formik.errors.slotId)}
                helperText={formik.touched.slotId && formik.errors.slotId}
                label="Change Slot"
                placeholder="Change Slot"
                name="slotId"
                disableClearable={true}
                optionsType={allSlots}
                required
                getOptionLabel={(option: any) => option.columnOrder.toString() || ""}
                value={allSlots.find((st: any) => st.id === formik.values.slotId) || null}
                onChange={(option: any) => {
                  option && option.id !== 0 ? formik.setFieldValue("slotId", option.id) : "";
                }}
              />
            </Box>
          </Grid>

          <Grid container item xs={12} md={12}>
            <Grid item xs={12} md={9}>
              <Box textAlign="left" mt={1}>
                <CommonButton
                  cssClass="customSubmitBtn"
                  onClick={() => {
                    resetSlotForm();
                  }}
                >
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  disable={!formik.dirty || !formik.isValid}
                  onClick={() => {
                    formik.submitForm();
                  }}
                >
                  {(redirectedFrom.payload.yard.drawerOpenedFor === "vehicleNumber" &&
                    !vehicleDetailsResponse.allotedYardDetails) ||
                  Boolean(removedFromYard)
                    ? "Park at Yard"
                    : "Update"}
                </CommonButton>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} className={classes.topRemoveButton}>
              {(redirectedFrom.payload.yard.drawerOpenedFor === "image" ||
                Boolean(vehicleDetailsResponse.allotedYardDetails)) &&
              !Boolean(removedFromYard) ? (
                <NewCommonButton
                  icon={<DeleteIcon />}
                  isDelete={true}
                  cssClass={"button"}
                  onClick={() => removeFromYard()}
                >
                  Remove
                </NewCommonButton>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <TransitionDialog
        isOpen={isOpenDeleteDailog}
        handleClose={handleCloseDeleteDialog}
        heading={"Confirmation"}
        handleConfirm={handleDeleteDialog}
      >
        Are you sure you want to remove this vehicle from yard?
      </TransitionDialog>
    </div>
  );
}
